import { render, staticRenderFns } from "./session-expired.view.vue?vue&type=template&id=72efcc6f&scoped=true"
import script from "./session-expired.view.vue?vue&type=script&lang=js"
export * from "./session-expired.view.vue?vue&type=script&lang=js"
import style0 from "./session-expired.view.vue?vue&type=style&index=0&id=72efcc6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72efcc6f",
  null
  
)

export default component.exports